import {observer} from 'mobx-react';
import LieuTimeNote from './LieuTimeNote';

const DoubleOvertimeCell = observer(({model}) => {
  return (
    <div>
      <div>{model.doubleOvertime}</div>
      <LieuTimeNote lieuTime={model.doubleOvertimeLieuTime}/>
    </div>
  );
});

export default DoubleOvertimeCell;
